import React from 'react'
import classNames from 'classnames'
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'

interface Props {
  icon: React.ReactNode
  title: React.ReactNode
  description: React.ReactNode
  label?: React.ReactNode
  className?: string
}

const styles = ({ spacing, palette }: Theme) => createStyles({
  root: {
    borderRadius: 7,
    textAlign: 'center',
    position: 'relative',
    padding: spacing() * 2,
  },
  label: {
    height: 'auto',
    position: 'absolute',
    top: spacing() * 2,
    right: spacing() * 2,
    borderRadius: 3,
    textTransform: 'uppercase',
    backgroundColor: '#FF5C5C',
    color: palette.common.white,
  },
  icon: {
    width: 80,
    height: 80,
    margin: '0 auto',
  },
  title: {
    margin: `${spacing()} auto`,
  },
  description: {
    opacity: .5,
    fontSize: 14,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameTypeCard: React.FC<InjectedProps> = ({ icon, title, description, label, classes, className, ...props }) => {
  return (
    <Paper
      {...props}
      elevation={0}
      className={classNames(className, classes.root)}
    >
      {
        label && (
          <Chip
            className={classes.label}
            label={<strong>{label}</strong>}
          />
        )
      }
      <div className={classes.icon}>
        {icon}
      </div>
      <Typography
        variant="h5"
        component="h2"
        align="inherit"
        color="inherit"
        className={classes.title}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        align="inherit"
        color="inherit"
        className={classes.description}
      >
        {description}
      </Typography>
    </Paper>
  )
}

export default withStyles(styles)(GameTypeCard)
